/* tslint:disable */
/* eslint-disable */
/**
 * WSK APIドキュメント
 *  WSK APIドキュメント  ## レスポンス形式 - result     - **status**：     - **message**：     - **system_date**：     - **pageno**： - data     - list         - **datacount**：         - **maxcount**：         - **list**：   ### result.status - **success**：正常終了 - **error**：入力エラー、権限エラー - **warning**：警告で、通知する必要のあるメッセージがある - **info**：正常処理で、通知する必要のあるメッセージがある  
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { AlertMstItemData } from './AlertMstItemData';
import {
    AlertMstItemDataFromJSON,
    AlertMstItemDataFromJSONTyped,
    AlertMstItemDataToJSON,
    AlertMstItemDataToJSONTyped,
} from './AlertMstItemData';
import type { ResponseResult } from './ResponseResult';
import {
    ResponseResultFromJSON,
    ResponseResultFromJSONTyped,
    ResponseResultToJSON,
    ResponseResultToJSONTyped,
} from './ResponseResult';

/**
 * 
 * @export
 * @interface ResponseAlertMstItem
 */
export interface ResponseAlertMstItem {
    /**
     * 
     * @type {ResponseResult}
     * @memberof ResponseAlertMstItem
     */
    result: ResponseResult;
    /**
     * 
     * @type {AlertMstItemData}
     * @memberof ResponseAlertMstItem
     */
    data: AlertMstItemData;
}

/**
 * Check if a given object implements the ResponseAlertMstItem interface.
 */
export function instanceOfResponseAlertMstItem(value: object): value is ResponseAlertMstItem {
    if (!('result' in value) || value['result'] === undefined) return false;
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function ResponseAlertMstItemFromJSON(json: any): ResponseAlertMstItem {
    return ResponseAlertMstItemFromJSONTyped(json, false);
}

export function ResponseAlertMstItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseAlertMstItem {
    if (json == null) {
        return json;
    }
    return {
        
        'result': ResponseResultFromJSON(json['result']),
        'data': AlertMstItemDataFromJSON(json['data']),
    };
}

export function ResponseAlertMstItemToJSON(json: any): ResponseAlertMstItem {
    return ResponseAlertMstItemToJSONTyped(json, false);
}

export function ResponseAlertMstItemToJSONTyped(value?: ResponseAlertMstItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'result': ResponseResultToJSON(value['result']),
        'data': AlertMstItemDataToJSON(value['data']),
    };
}

